<!--
 * @Author: guoyu
 * @Date: 2020-05-14 21:26:11
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-10 14:54:37
 * @Description: 简单表格组件
 -->
<template>
  <table class="table-default">
    <thead class="thead-default">
      <tr class="thead-tr-default">
        <th
          class="th-default"
          v-for="(item, index) in headOptions"
          :key="'h' + index"
          :width="item.width || undefined"
        >
          <slot name="head" :item="item">
            {{ typeof item === 'object' ? item.label : item }}
          </slot>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        class="tr-default"
        v-for="(item, index) in options"
        :key="'tr' + index"
        :class="{ stripe }"
      >
        <td
          class="td-default"
          v-for="(headItem, tdIndex) in headOptions"
          :key="'td-' + index + '-' + tdIndex"
        >
          <slot
            :name="headItem.name || ''"
            :trInfo="item"
            :trIndex="index"
            :index="tdIndex"
            :valKey="headItem.key"
            :val="item[headItem.key]"
            >{{ item[headItem.key] }}</slot
          >
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import i18n from '@/locales/index'
export default {
  props: {
    // 头部配置
    headOptions: {
      type: Array,
      default: initHead
    },
    // 表内容
    options: {
      type: Array,
      default: () => []
    },
    // 條文
    stripe: {
      type: Boolean,
      default: false
    }
  }
};
/**
 * @description: 表明应有字段
 */
function initHead() {
  return [
    {
      label: i18n.t('components_common_table_index_1946'), // 表头
      key: 'key', // 表内容展示是的属性
      name: '' // 自定义插入slot
    }
  ];
}
</script>
<style lang="scss" scoped>
.table-default {
  border-collapse: collapse;
}
.thead-default {
  font-size: 14px;
  color: #666666;
}
.th-default {
  padding: 12px 0px;
  border-top: solid 1px rgba(255, 137, 30, 0.5);
  border-bottom: solid 1px rgba(255, 137, 30, 0.5);
}
.td-default {
  height: 77px;
  text-align: center;
}
.stripe:nth-child(2n) {
  background: #f6f6f6;
}
</style>
